import THDStorageUtils, { LOCAL_STORAGE } from '@thd-olt-global/thd-storage-utils';
import { FALLBACK_USER_ID } from '../constants';
import { logger } from './logger';

export const getMcvisID = () => {
  return typeof window !== 'undefined'
    ? window.THDCustomer?.default?.mcvisID || FALLBACK_USER_ID : FALLBACK_USER_ID;
};

export const getSvocId = () => {
  return typeof window !== 'undefined' ? window.THDCustomer?.default?.svocID || null : null;
};

export const getUserName = () => {
  return typeof window !== 'undefined' ? window.THDCustomer?.default?.name || null : null;
};

// Read through this helper, not window.location, so it can be stubbed —
// jsdom's window.location isn't redefinable.
export const getHostname = () => {
  return typeof window !== 'undefined'
    ? (window.location?.hostname || '').toLowerCase() : '';
};

export const getPagePath = () => {
  return typeof window !== 'undefined'
    ? new URL(window.document.documentURI).pathname
    : '';
};

// Same as getPagePath() — kept until remaining window.parent references
// (leftover from moving out of an iframe) are cleaned up.
export const getParentPagePath = getPagePath;

// Fallback path-matching rules — see .claude/context/page-classification.md.
const PAGE_TYPE_RULES = [
  [/^\/s\//, 'search'],
  [/^\/b\/.*Ntt-/, 'search'],
  [/^\/p\/paint\/config\//, 'magic pip'],
  [/^\/p\/rental\/reservations\//, 'tool:productrental:reservation'],
  [/^\/p\/rental\//, 'tool:productrental:pip'],
  [/^\/p\/sets/, 'bip'],
  [/^\/p\//, 'pip'],
  [/^\/pep\//, 'pep'],
  [/^\/b\//, 'browse'],
  [/^\/c\//, 'content'],
  [/^\/l\//, 'storefinder'],
  [/^\/collection\//, 'collection'],
  [/^\/compare\//, 'compare'],
  [/^\/buyitagain/, 'buy it again page'],
  [/^\/list\/view\/details\/shared\//, 'list details>shared'],
  [/^\/list\/view\/details\//, 'list details'],
  [/^\/gift-cards\//, 'giftcard'],
  [/^\/cart(\/|$)/, 'cart'],
  [/^\/bath-renovation/, 'bathroom design studio'],
  [/^\/configurator-projects/, 'flooring projects'],
  [/^\/projects\/.+/, 'project details'],
  [/^\/projects\/?$/, 'projects'],
  [/^\/?$/, 'homepage'],
];

const pageTypeFromPath = (path = '') => {
  const normalised = path.replace(/^\/render[^/]*/, '');
  return PAGE_TYPE_RULES.find(([pattern]) => pattern.test(normalised))?.[1] ?? 'unknown';
};

// The page type the site reports to analytics. ⚠ Open-ended vocabulary, from window.digitalData.
// See .claude/context/page-classification.md.
export const getCanonicalPageType = () => {
  return window?.digitalData?.page?.pageInfo?.pageType || pageTypeFromPath(getPagePath());
};

export const getItemId = () => {
  // Path structure, not page type: an item id is the last segment of a /p/ URL.
  // Every product variant (pip, bip, rental, paint config) shares that shape.
  if (!/^\/p\//.test(getPagePath())) return null;

  return getPagePath().split('/').at(-1);
};

export const getRecentSearchTerms = () => {

  try {
    const history = THDStorageUtils.get(LOCAL_STORAGE, { key: 'header_search_history' });
    if (!history || history === 'undefined') return [];
    return JSON.parse(history).map((term) => {
      try {
        return decodeURIComponent(term.keyword);
      } catch {
        return term.keyword;
      }
    });

  } catch (error) {
    logger.error({
      message: `Error occurred while accessing local storage - ${'header_search_history'}`,
      error
    });
    return [];
  }
};
